import React, { useMemo } from 'react';
import { useField } from 'formik';
import { FieldLabel, FieldValue, Toggle } from '@td/ui';
import { translate } from '@td/shared_utils';
import { fieldTypes } from '../../constants';
import { useProviderPanel } from '../../contexts/provider-panel-context';
import styles from './styles.module.scss';
import { newPatientStatusLabel } from '../../utils';

const AcceptNewPatientsField = React.memo(() => {
  const [{ value }, , { setValue }] = useField(fieldTypes.ACCEPT_NEW_PATIENTS);
  const { provider: { licenses, providerExtension } } = useProviderPanel();
  const hasLicenses = !!licenses.length;

  const newPatientsStatusNote = useMemo(() => {
    return newPatientStatusLabel(
      'provider_panel.form.fields.accept_new_patients.status',
      { licenses, providerExtension }
    );
  }, [licenses, providerExtension]);

  return (
    <FieldLabel>
      <div className={styles.labelWrapper}>
        <div>
          {translate(null, 'provider_panel.form.fields.accept_new_patients', 'label')}
        </div>
        <Toggle
          name={fieldTypes.ACCEPT_NEW_PATIENTS}
          active={!!(value && hasLicenses)}
          onChange={setValue}
          disabled={!hasLicenses}
        />
      </div>

      <FieldValue className={styles.subLabelWrapper}>
        <div>
          <div>
            {translate(null, 'provider_panel.form.fields.accept_new_patients.note', 'with_licenses')}
          </div>
          {providerExtension && !providerExtension.acceptingNewPatients && (
            <div>
              {newPatientsStatusNote}
            </div>
          )}
        </div>
      </FieldValue>
    </FieldLabel>
  );
});

AcceptNewPatientsField.displayName = 'AcceptNewPatientsField';

export default AcceptNewPatientsField;
